import { render, staticRenderFns } from "./LocationsModified.vue?vue&type=template&id=12ebe63b"
import script from "./LocationsModified.vue?vue&type=script&lang=js"
export * from "./LocationsModified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports